export default {
	'the-rating': 'the rating?',
	rating: 'rating',
	'add-new-rating': 'add new rating',
}